import React from 'react';
import { RaaRoles } from '../../../../utility/SecurityRules';
import HasRolePrivileges from '../../../highorder/HasRolePrivileges';
/* istanbul ignore next */
function RenderAlertLimitReached() {
  return (
    <HasRolePrivileges
      targetRoleList={[RaaRoles.ADMIN]}
      alternativeComponent={(<span className="badge badge-danger mx-1">Limit Reached.</span>)}
    >
      <span className="btn-sm btn-danger mx-2 py-0 px-1">
        <a href="/s/subscription/billing/change-plan" className="text-white">
          <span style={{ fontSize: 'smaller' }}>
            Limit Reached.
          </span>
        </a>
        {' '}
      </span>
      <a href="/s/subscription/billing/change-plan">Upgrade.</a>
    </HasRolePrivileges>
  );
}

export default RenderAlertLimitReached;
